import { memo } from 'react';
import styled from 'foundations-theming/utils';
import { flexColumnStyles } from '../constants/flexColumnStyles';
import { View } from 'foundations-components/components/View';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { SkeletonGradient } from 'conversations-skeleton-state/components/SkeletonGradient';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingWrapper = styled.div.withConfig({
  displayName: "EditorLoadingState__LoadingWrapper",
  componentId: "sc-1rjbjs8-0"
})(["", " flex-grow:1;"], flexColumnStyles);
const EditorLoadingState = /*#__PURE__*/memo(({
  minHeight
}) => {
  return /*#__PURE__*/_jsxs(LoadingWrapper, {
    children: [/*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: minHeight ? `${minHeight}px` : 'auto',
      flexGrow: 1,
      padding: "500",
      alignItems: "stretch",
      children: /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "100%",
        blockSize: "auto",
        minBlockSize: "15px"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      inlineSize: "100%",
      blockSize: "50px",
      justifyContent: "end",
      alignItems: "center",
      overflow: "hidden",
      "data-loading": "true",
      children: [/*#__PURE__*/_jsx(SkeletonGradient, {}), /*#__PURE__*/_jsx(View, {
        position: "absolute",
        blockSize: "34px",
        inlineSize: "90px",
        backgroundColor: "fill-surface-default",
        marginInlineEnd: "400"
      })]
    })]
  });
});
EditorLoadingState.displayName = 'EditorLoadingState';
export default EditorLoadingState;